import type { Airport, RunwayEnd } from '../types';
import { FT_M } from '../geo';

const rw = (ident: string, reciprocal: string, lat: number, lon: number, headingTrue: number,
            lengthFt: number, widthFt: number, displacedFt: number): RunwayEnd =>
  ({ ident, reciprocal, lat, lon, headingTrue, lengthM: lengthFt * FT_M, widthM: widthFt * FT_M, displacedM: displacedFt * FT_M });

/** Buchanan Field, Concord CA. Source: OurAirports runways.csv / airports.csv (2026-09-15). */
export const KCCR: Airport = {
  icao: 'KCCR', lat: 37.9897, lon: -122.056999, elevationFt: 26, geoidUndulationM: -32.4,
  runways: [
    rw('01L', '19R', 37.981998, -122.060997, 23.5, 5001, 150, 600),
    rw('19R', '01L', 37.994499, -122.054001, 203.5, 5001, 150, 601),
    rw('01R', '19L', 37.983898, -122.057999, 23.5, 2770, 75, 0),
    rw('19L', '01R', 37.990898, -122.055000, 203.5, 2770, 75, 0),
    rw('14L', '32R', 37.996498, -122.058998, 153.5, 4602, 150, 900),
    rw('32R', '14L', 37.985199, -122.052002, 333.5, 4602, 150, 350),
    rw('14R', '32L', 37.995899, -122.059998, 153.5, 2798, 75, 0),
    rw('32L', '14R', 37.988998, -122.056000, 333.5, 2798, 75, 0),
  ],
};

export function runwayByIdent(airport: Airport, ident: string): RunwayEnd {
  const r = airport.runways.find(x => x.ident === ident);
  if (!r) throw new Error(`unknown runway ${ident} at ${airport.icao}`);
  return r;
}
